module.exports = __webpack_public_path__ + "img/ROROCCCO01180277.4d657334.png";